import { ReactNode } from "react";
import styled from "styled-components";

const ChartToolTip = ({ children }: { children: ReactNode }) => {
  return <ChartToolTipContainer>{children}</ChartToolTipContainer>;
};

const ChartToolTipContainer = styled.div`
  padding: 0 12px;
  color: ${({ theme }) => theme.colors.dark};
  background-color: white;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.dark};
`;

const ChartToolTipHeader = styled.h3``;

const ChartToolTipBody = styled.div<{ $fontSize?: string }>`
  ${(props) => props.$fontSize && `font-size: ${props.$fontSize};`}
  margin: 16px 0;
  display: flex;
  align-items: center;
`;

export { ChartToolTip, ChartToolTipBody, ChartToolTipHeader };
